import { Injectable } from "@angular/core";
import { AssociationMongo } from "app/models/association";

@Injectable({
    providedIn: 'root'
  })
export class AssociationHelper {
    selectedEpe: string = ''
    selectedProject: string = ''

    activeEpe: string = ''
    activeProject: string = ''

    MEETING_FORM?: number

    // application_type of the selected project ('service1' = Mentoring, 'service2' = PSS)
    serviceType: string = ''

    associations: AssociationMongo[] | null = null

    constructor() {

    }

    clear(){
        this.selectedEpe = ''
        this.selectedProject = ''
        this.activeEpe = ''
        this.activeProject = ''
        this.MEETING_FORM = 0
        this.serviceType = ''
    }

    setServiceType(type: string | undefined): void {
        this.serviceType = type || ''
    }

    getServiceType(): string {
        return this.serviceType
    }

    isPss(): boolean {
        return this.serviceType === 'service2'
    }

    setMeetingForm(meeting: number): void{

        this.MEETING_FORM = meeting

    }

    getMeetingForm(): number{
        return this.MEETING_FORM || 0
    }

    setAssociations(associations: AssociationMongo[]): void{
        this.associations = associations
    }

    getAssociations(): AssociationMongo[] | null{
        return this.associations
    }

    setAssociation(project_id: string, epe_id: string, role: string): void{
        if(!this.associations)
            return
        let index = this.associations.findIndex( x => this.matchAssoc(x, project_id, epe_id))
        if(index < 0)
            return
        this.associations[index].association_status = role
    }

    getAssociation(project_id: string, epe_id: string): AssociationMongo | undefined {
        if(!this.associations)
            return undefined
        return this.associations.find( x => this.matchAssoc(x, project_id, epe_id))
    }

    private matchAssoc(x: AssociationMongo, project_id: string, epe_id: string): boolean {
        const pid = x.project_application_id ?? x.project_id
        const eid = x.epe_application_id ?? x.epe_id
        return pid == project_id && eid == epe_id
    }

    getActiveEpe(): string {
        return this.activeEpe
    }

    setActiveEpe(epe_id: string): void {
        this.activeEpe = epe_id
    }

    getActiveProject(): string {
        return this.activeProject
    }

    setActiveProject(project_id: string): void {
        this.activeProject = project_id
    }

    getSelectedEpe(): string {
        return this.selectedEpe
    }

    isEpeSelected(epe_id: string): boolean {
        return epe_id === this.selectedEpe
    }

    setSelectedEpe(epe_id: string): void {

            this.selectedEpe = epe_id
    }

    getSelectedProject(): string {
        return this.selectedProject
    }

    isProjectSelected(project_id: string): boolean {
        return project_id === this.selectedProject
    }

    setSelectedProject(project_id: string): void {
        if(!this.isProjectSelected(project_id))
            this.selectedProject = project_id
    }
}
